import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "style", "placeholder", "label", "name", "isDisabled", "separator", "children", "onChange", "onSelectionChange", "onFocus", "onBlur", "defaultValue", "value"],
    _excluded2 = ["isDisabled", "children"],
    _excluded3 = ["isDisabled", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useEffect, useRef, forwardRef } from 'react';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import Icon from '../Icon';
import { Styled } from './Dropdown.styles';
import { wrapEvent } from '../../tools';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var Dropdown = forwardRef(function Dropdown(_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      style = _ref.style,
      placeholder = _ref.placeholder,
      label = _ref.label,
      name = _ref.name,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$separator = _ref.separator,
      separator = _ref$separator === void 0 ? ':' : _ref$separator,
      children = _ref.children,
      onChange = _ref.onChange,
      onSelectionChange = _ref.onSelectionChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-dropdown"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var selectEl = useRef();

  var _useState = useState({
    type: '',
    label: placeholder
  }),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var handleChange = function handleChange(event) {
    var index = event.target.selectedIndex;
    var label = event.target[index].text;
    var value = event.target.value;
    setSelected({
      type: value,
      label: label
    });
  };

  useEffect(function () {
    if (selectEl.current.options.length > 0) {
      var index = selectEl.current.selectedIndex;
      var _label = selectEl.current.options[index].text;
      setSelected({
        type: value,
        label: _label
      });
    }
  }, [children, value]);
  return _jsxs(Styled.Dropdown, {
    className: className,
    style: style,
    "aria-disabled": isDisabled,
    children: [_jsxs(Styled.DropdownContent, {
      "aria-hidden": true,
      children: [label && _jsxs(Styled.DropdownContentLabel, {
        children: [label, separator]
      }), _jsx(Styled.DropdownContentSelected, {
        children: selected.label
      }), _jsx(Styled.DropdownContentIcon, {
        children: _jsx(Icon, {
          icon: "chevron-down",
          size: 14,
          color: "var(--dentsu-color-b550)"
        })
      })]
    }), _jsxs(Styled.DropdownSelect, _objectSpread(_objectSpread({
      disabled: isDisabled,
      "aria-invalid": false,
      ref: selectEl,
      onChange: wrapEvent(onChange, handleChange),
      defaultValue: defaultValue,
      value: value,
      name: name,
      id: id
    }, props), {}, {
      children: [placeholder && _jsx(Styled.DropdownOption, {
        value: "",
        children: placeholder
      }), children]
    })), _jsx(Styled.DropdownBackdrop, {})]
  });
});

var DropdownOption = function DropdownOption(_ref2) {
  var _ref2$isDisabled = _ref2.isDisabled,
      disabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return _jsx(Styled.DropdownOption, _objectSpread(_objectSpread({
    disabled: disabled
  }, rest), {}, {
    children: children
  }));
};

var DropdownOptionGroup = function DropdownOptionGroup(_ref3) {
  var _ref3$isDisabled = _ref3.isDisabled,
      disabled = _ref3$isDisabled === void 0 ? false : _ref3$isDisabled,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return _jsx(Styled.DropdownOptionGroup, _objectSpread(_objectSpread({
    disabled: disabled
  }, rest), {}, {
    children: children
  }));
};

Dropdown.Option = DropdownOption;
Dropdown.OptionGroup = DropdownOptionGroup;
Dropdown.displayName = 'Dropdown';
export default Dropdown;